import { render, staticRenderFns } from "./UpdateRuleFeedback.vue?vue&type=template&id=aec07bb6&scoped=true&"
import script from "./UpdateRuleFeedback.vue?vue&type=script&lang=js&"
export * from "./UpdateRuleFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec07bb6",
  null
  
)

export default component.exports